export interface OrderNotifData {
  pseudo: string;
  phone: string;
  address: string;
  items: {
    name: string;
    quantity: number;
    price: number;
    image_url?: string | null;
  }[];
  total: number;
  orderId: number;
  latitude?: number;
  longitude?: number;
}

const RECIPIENTS = [
  {
    phone: process.env.REACT_APP_WHATSAPP_NUMBER_1!,
    apikey: process.env.REACT_APP_CALLMEBOT_APIKEY_1!,
  },
  {
    phone: process.env.REACT_APP_WHATSAPP_NUMBER_2!,
    apikey: process.env.REACT_APP_CALLMEBOT_APIKEY_2!,
  },
];

function buildMessage(data: OrderNotifData): string {
  const mapsLink =
    data.latitude && data.longitude
      ? `\n📌 GPS : https://maps.google.com/?q=${data.latitude},${data.longitude}`
      : "";

  const itemLines = data.items.flatMap((i) => {
    const subtotal = (i.price * i.quantity).toLocaleString("fr-FR");
    const lines = [`  • ${i.name} x${i.quantity} — ${subtotal} FCFA`];
    if (i.image_url) lines.push(`    🖼️ ${i.image_url}`);
    return lines;
  });

  const lines = [
    "🛒 *Nouvelle commande Somzita*",
    "──────────────────",
    `👤 Pseudo : *${data.pseudo}*`,
    `📞 Tél : ${data.phone}`,
    `📍 Adresse : ${data.address}${mapsLink}`,
    "──────────────────",
    "*Produits :*",
    ...itemLines,
    "──────────────────",
    `💰 *Total : ${data.total.toLocaleString("fr-FR")} FCFA*`,
    `🔖 Commande #${data.orderId}`,
    `🕐 ${new Date().toLocaleString("fr-FR")}`,
  ];

  return lines.join("\n");
}

async function sendToOne(
  phone: string,
  apikey: string,
  message: string,
): Promise<void> {
  if (!phone || !apikey) return;
  const url = `https://api.callmebot.com/whatsapp.php?phone=${phone}&text=${encodeURIComponent(message)}&apikey=${apikey}`;
  try {
    await fetch(url, { method: "GET", mode: "no-cors" });
  } catch {
    console.warn(`WhatsApp notification failed for ${phone}`);
  }
}

export async function sendWhatsAppNotification(
  data: OrderNotifData,
): Promise<void> {
  const message = buildMessage(data);
  await Promise.all(
    RECIPIENTS.map((r) => sendToOne(r.phone, r.apikey, message)),
  );
}
